import { render, staticRenderFns } from "./GreenBuildingCertificate.vue?vue&type=template&id=6029a144&scoped=true&"
import script from "./GreenBuildingCertificate.vue?vue&type=script&lang=js&"
export * from "./GreenBuildingCertificate.vue?vue&type=script&lang=js&"
import style0 from "./GreenBuildingCertificate.vue?vue&type=style&index=0&id=6029a144&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6029a144",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/home/runner/work/PMS_Client/PMS_Client/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('6029a144')) {
      api.createRecord('6029a144', component.options)
    } else {
      api.reload('6029a144', component.options)
    }
    module.hot.accept("./GreenBuildingCertificate.vue?vue&type=template&id=6029a144&scoped=true&", function () {
      api.rerender('6029a144', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/modules/ccd/tenancy/greenOperation/assessments/GreenBuildingCertificate.vue"
export default component.exports